import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import useSearchModal from '../../../hooks/useSearchModal';
import {
  hidePopupHeader,
  showPopupHeader,
  setCurrentState,
  setAdriverSelectedCity
} from '../../../actions';
import { Input, InputTypeMap } from '../../ui/Input';
import { NewSearchCity } from '../NewSearchCities/NewSearchCity';
import { SearchPopupContent } from './styled';
import { NewSearchPopupProps } from './types';
import { selectSearchFormResetButtonIsDisabled } from '../../../store/selectors';
import { Modal } from '../../ui/Modal';
import { ANY_CITY_ID, Cities } from '../../../utils/helpers/constants';

export const NewSearchPopup = ({
  isOpen,
  isCreate,
  popupTitle,
  closeHandler,
  closePopupHandler
}: NewSearchPopupProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const inputEl = useRef<HTMLInputElement | null>(null);
  const { change, submit } = useForm();
  const { values } = useFormState();
  const resetButtonIsDisabled = useSelector(
    selectSearchFormResetButtonIsDisabled
  );

  const {
    searchString,
    onFocusHandler,
    onResetHandler,
    onChangeHandler,
    setIsSubmittedForm,
    defaultCancelHandler,
    onBlurHandler,
    isInputOnFocus
  } = useSearchModal(inputEl);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.keyCode === 13 && e.shiftKey === false) {
      e.preventDefault();
      setIsSubmittedForm(true);
    }
  };

  const cancelHandler = () => {
    dispatch(showPopupHeader());
    defaultCancelHandler();
  };

  const onFocusInputHandler = () => {
    dispatch(hidePopupHeader());
    onFocusHandler();
  };

  const resetHandler = () => {
    change('city_id', ANY_CITY_ID);
    dispatch(setCurrentState({ ...values, city_id: ANY_CITY_ID }));
    dispatch(setAdriverSelectedCity(Cities.Baku.az));
  };

  const onConfirm = () => {
    closeHandler();
    submit();
  };

  return (
    <Modal
      isOpen={isOpen}
      modalId="select-city"
      onClose={closeHandler}
      cypress="new-search-popup--cities"
      title={popupTitle}
      resetText={t('common.reset')}
      onReset={resetHandler}
      confirmText={t('search.city_search.ready')}
      resetIsDisabled={
        resetButtonIsDisabled || isInputOnFocus || !!searchString
      }
      onConfirm={onConfirm}
    >
      <SearchPopupContent>
        <Input
          refEl={inputEl}
          value={searchString}
          onKeyDown={handleKeyDown}
          type={InputTypeMap.search}
          onResetHandler={onResetHandler}
          id="search-form-search-by-number"
          stat="new-search-find-city"
          onChangeHandler={onChangeHandler}
          onFocusHandler={onFocusInputHandler}
          placeholder={t('new_search.search_city_placeholder')}
          isShowReset={!!searchString}
          isInsideModalWithAnimation
          onBlurHandler={onBlurHandler}
        />
        <NewSearchCity
          closePopupHandler={closePopupHandler}
          isFocused={isInputOnFocus}
          {...{ searchString, cancelHandler, isCreate }}
        />
      </SearchPopupContent>
    </Modal>
  );
};
